
// @ts-nocheck


export const localeCodes =  [
  "en",
  "pt",
  "ca",
  "es",
  "fr",
  "it",
  "nl",
  "de"
]

export const localeLoaders = {
  "en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__tmp_build_38bfee86_code_lang_en_json" */), cache: true }],
  "pt": [{ key: "../lang/pt_PT.json", load: () => import("../lang/pt_PT.json" /* webpackChunkName: "locale__tmp_build_38bfee86_code_lang_pt_PT_json" */), cache: true }],
  "ca": [{ key: "../lang/ca.json", load: () => import("../lang/ca.json" /* webpackChunkName: "locale__tmp_build_38bfee86_code_lang_ca_json" */), cache: true }],
  "es": [{ key: "../lang/es.json", load: () => import("../lang/es.json" /* webpackChunkName: "locale__tmp_build_38bfee86_code_lang_es_json" */), cache: true }],
  "fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__tmp_build_38bfee86_code_lang_fr_json" */), cache: true }],
  "it": [{ key: "../lang/it.json", load: () => import("../lang/it.json" /* webpackChunkName: "locale__tmp_build_38bfee86_code_lang_it_json" */), cache: true }],
  "nl": [{ key: "../lang/nl.json", load: () => import("../lang/nl.json" /* webpackChunkName: "locale__tmp_build_38bfee86_code_lang_nl_json" */), cache: true }],
  "de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__tmp_build_38bfee86_code_lang_de_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": ""
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "iso": "en",
      "name": "English",
      "files": [
        "lang/en.json"
      ]
    },
    {
      "code": "pt",
      "iso": "pt-PT",
      "name": "Português",
      "files": [
        "lang/pt_PT.json"
      ]
    },
    {
      "code": "ca",
      "iso": "ca",
      "name": "Català",
      "files": [
        "lang/ca.json"
      ]
    },
    {
      "code": "es",
      "iso": "es",
      "name": "Español",
      "files": [
        "lang/es.json"
      ]
    },
    {
      "code": "fr",
      "iso": "fr",
      "name": "Français",
      "files": [
        "lang/fr.json"
      ]
    },
    {
      "code": "it",
      "name": "Italiano",
      "files": [
        "lang/it.json"
      ]
    },
    {
      "code": "nl",
      "name": "Nederlands",
      "files": [
        "lang/nl.json"
      ]
    },
    {
      "code": "de",
      "name": "Deutsch",
      "files": [
        "lang/de.json"
      ]
    }
  ],
  "defaultLocale": "pt",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": true,
  "langDir": "lang/",
  "rootRedirect": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const nuxtI18nOptionsDefault = {
  "experimental": {
    "localeDetector": ""
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [],
  "defaultLocale": "",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "rootRedirect": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false
}

export const normalizedLocales = [
  {
    "code": "en",
    "iso": "en",
    "name": "English",
    "files": [
      {
        "path": "lang/en.json"
      }
    ]
  },
  {
    "code": "pt",
    "iso": "pt-PT",
    "name": "Português",
    "files": [
      {
        "path": "lang/pt_PT.json"
      }
    ]
  },
  {
    "code": "ca",
    "iso": "ca",
    "name": "Català",
    "files": [
      {
        "path": "lang/ca.json"
      }
    ]
  },
  {
    "code": "es",
    "iso": "es",
    "name": "Español",
    "files": [
      {
        "path": "lang/es.json"
      }
    ]
  },
  {
    "code": "fr",
    "iso": "fr",
    "name": "Français",
    "files": [
      {
        "path": "lang/fr.json"
      }
    ]
  },
  {
    "code": "it",
    "name": "Italiano",
    "files": [
      {
        "path": "lang/it.json"
      }
    ]
  },
  {
    "code": "nl",
    "name": "Nederlands",
    "files": [
      {
        "path": "lang/nl.json"
      }
    ]
  },
  {
    "code": "de",
    "name": "Deutsch",
    "files": [
      {
        "path": "lang/de.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true

export const STRATEGIES = {
  "PREFIX": "prefix",
  "PREFIX_EXCEPT_DEFAULT": "prefix_except_default",
  "PREFIX_AND_DEFAULT": "prefix_and_default",
  "NO_PREFIX": "no_prefix"
}
export const DEFAULT_LOCALE = ""
export const DEFAULT_STRATEGY = "prefix_except_default"
export const DEFAULT_TRAILING_SLASH = false
export const DEFAULT_ROUTES_NAME_SEPARATOR = "___"
export const DEFAULT_LOCALE_ROUTE_NAME_SUFFIX = "default"
export const DEFAULT_DETECTION_DIRECTION = "ltr"
export const DEFAULT_BASE_URL = ""
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"


